<template>
  <h1 class="text-4xl font-bold">
    <slot></slot>
  </h1>
</template>
